export const OktaClientId = '0oa15aymctiioGwei697'
export const ENV = 'murphy' as string
export const OVERSIGHT_ENV_NAME = 'oversight'
export const GCS_ENV_NAME = 'murphy'
export const SUBDOMAIN_SUFFIX = 'gcs'
